import React, { Component } from 'react'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class EditDefaultSearch extends Component {

    state = {
        defaultSearch: this.props.defaultSearch,
    }

    onSave = () => {
        this.props.onSave(this.state)
    }

    render() {
        const { defaultSearch = false } = this.state

        return (
          <Modal
            narrow
            extraClassName="EditDefaultSearch"
            onCancel={this.props.onClose}
            onSave={this.onSave}
            saveText="Save"
            mode="edit"
            title="Default Search">
            <Form>
                <div>
                    <label className="radio">
                        <input
                            type="radio"
                            checked={!defaultSearch}
                            onChange={e => this.setState({ defaultSearch: false })} />
                            No
                    </label>
                    <label className="radio">
                        <input
                            type="radio"
                            checked={defaultSearch}
                            onChange={e => this.setState({ defaultSearch: true })} />
                            Yes
                    </label>
                </div>
            </Form>
          </Modal>
        )
    }
}

export default EditDefaultSearch



// WEBPACK FOOTER //
// ./src/components/LBUs/EditDefaultSearch.js